import { RightPackageTypeEnum } from '@/api/rights/types';

interface SuccessOverlayImgInfo { [key:number]: {
  width: number;
  height: number;
  img: string;
  };
}

/** 金融权益弹窗上的按钮点击行为枚举 */
export const SuccessOverlayImgInfo:SuccessOverlayImgInfo = {
  /** 超级会员 */
  [RightPackageTypeEnum.SUPER_MEMBER_CARD]: {
    width: 303,
    height: 294,
    img: 'https://m.hellobike.com/resource/gallery/823/-MhYgaaI_success-buy-super.png',
  },
};
